import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PerfilAcessoTable from '../components/perfilAcesso/PerfilAcessoTable';

const PerfisAcesso: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Perfis de Acesso
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Gerencie os perfis de acesso do sistema
        </Typography>
      </Box>
      
      <PerfilAcessoTable />
    </Container>
  );
};

export default PerfisAcesso;
